// extracted by mini-css-extract-plugin
export default {"container":"yezHed","buttonLayout":"qDaU7T","textLayout":"O3nool"};